import React from 'react';
import editIcon from "../../../assets/icons/edit.svg";

interface EditButtonProps {
    onEdit: () => void; // Define the type of the `onDelete` function
}

const EditButton: React.FC<EditButtonProps> = ({ onEdit }) => {
    return (
        <div className="icon-button" onClick={onEdit}>
            <img
                id="popup"
                src={editIcon}
                alt="Edit Button"
                className="icon"                
            />
        </div>
    );
}

export default EditButton;